import V2IconsMagnifyingGlass from '~/components/v2/icons/MagnifyingGlass.vue'
import V2IconsPiggyBank from '~/components/v2/icons/PiggyBank.vue'
import V2IconsAirplane from '~/components/v2/icons/Airplane.vue'
import V2IconsHospital from '~/components/v2/icons/Hospital.vue'
import V2IconsClose from '~/components/v2/icons/Close.vue'
import V2IconsSuitcase from '~/components/v2/icons/Suitcase.vue'
import V2IconsCar from '~/components/v2/icons/Car.vue'
import V2IconsBookOpenText from '~/components/v2/icons/BookOpenText.vue'
import V2IconsTimer from '~/components/v2/icons/Timer.vue'
import V2IconsGlobe from '~/components/v2/icons/Globe.vue'
import V2IconsShield from '~/components/v2/icons/Shield.vue'
import V2IconsShieldRegular from '~/components/v2/icons/ShieldRegular.vue'
import V2IconsShieldCheck from '~/components/v2/icons/ShieldCheck.vue'

export const QUOTE_TYPE = [
  {
    label: 'Single Trip',
    key: 'single'
  },
  { 
    label: 'Annual multi trip',
    key: 'annual',
    tooltip: {
      title: 'Annual Multi-Trip',
      content: 'Do you travel regularly? An annual multi-trip policy can cover you for any number of trips (up to a maximum duration) within a 12-month period.'
    }
  }
]

export const AUTHOR_ITEM = {
  name: 'Kate Browne',
  description: `
    Kate Browne is Compare Club's Head of Research and Insights. With nearly two decades of experience as a managing editor, news editor, investigative journalist, and broadcaster, Kate has worked at leading organisations including Yahoo Finance, Finder, CHOICE, and the ABC. Her expertise spans a variety of areas such as credit cards, travel insurance, car insurance, health insurance, and personal finance. Kate has written for major publications like the Sydney Morning Herald, The Age, and news.com.au, and her insights help Australians make informed decisions across a wide range of financial and insurance products.
  `,
  image: '/images/authors/rebrand/kate_browne.png',
  vertical: 'car insurance',
  tips: [
    `
      <strong>If your trip includes multiple destinations</strong>, you’ll want a policy that offers cover for every location. Also be mindful of other factors such as travel duration, age, any pre-existing conditions, your excess and level of cover. For example, a 40-year-old travelling solo to the UK for two weeks might pay around $45 for a basic policy, or over $150+ for comprehensive cover.
    `,
    `
      <strong>With pre-existing conditions:</strong> Long COVID isn’t always covered yet. If this matters to you, check policies carefully.
    `,
    `   
      <strong>Real reviews matter:</strong> Ask friends or read independent reviews before picking a provider. Avoid biased or uncontactable websites.
    `
  ]
}

export const PARTNER_ITEMS = [
  {
    image: 'https://asset.compareclub.com.au/travel-insurance/partners/insure-go.png',
    dimensions: {
      width: 97,
      height: 58
    }
  },
  {
    image: 'https://asset.compareclub.com.au/travel-insurance/partners/tick-travel-insurance.png',
    dimensions: {
      width: 97,
      height: 58
    }
  },
  {
    image: 'https://asset.compareclub.com.au/travel-insurance/partners/travel-protect.png',
    dimensions: {
      width: 95,
      height: 75
    }
  },
  {
    image: 'https://asset.compareclub.com.au/travel-insurance/partners/was-insurance.png',
    dimensions: {
      width: 95,
      height: 75
    }
  },
  {
    image: 'https://asset.compareclub.com.au/travel-insurance/partners/butter-insurance.svg',
    dimensions: {
      width: 88,
      height: 56
    }
  },
  {
    image: 'https://asset.compareclub.com.au/travel-insurance/partners/readyset-insurance.svg',
    dimensions: {
      width: 88,
      height: 56
    }
  },
  {
    image: 'https://asset.compareclub.com.au/travel-insurance/partners/stella.svg',
    dimensions: {
      width: 164,
      height: 44
    }
  },
  {
    image: 'https://asset.compareclub.com.au/travel-insurance/partners/insure4less.png',
    dimensions: {
      width: 164,
      height: 44
    }
  },
  {
    image: 'https://asset.compareclub.com.au/travel-insurance/partners/travel-insuranz.jpg',
    dimensions: {
      width: 164,
      height: 44
    }
  },
  {
    image: 'https://asset.compareclub.com.au/travel-insurance/partners/freely.png',
    dimensions: {
      width: 88,
      height: 53
    }
  }
]

export const WHY_CONSIDER_TRAVEL_INSURANCE = [
  {
    title: 'You could save serious money',
    description: `
      Avoid paying for bells and whistles you don’t need. If you’re not planning to go skydiving, you probably don’t need extreme sports cover. By shopping around, you can find a policy that gives you exactly what you need - and nothing you don’t. Save those dollars for sampling local cuisine and new experiences.
    `,
    icon: V2IconsPiggyBank,
    iconProps: {
      width: 48,
      height: 48
    }
  },
  {
    title: 'You’ll get cover that actually suits your trip',
    description: `
      Every traveller is different. Heading to a country with a reciprocal healthcare agreement? Great - you may not need the most comprehensive medical cover. Still, don’t skip on key inclusions, especially if you take medication or your kids have specific health needs, like asthma.
    `,
    icon: V2IconsAirplane,
    iconProps: {
      width: 48,
      height: 48
    }
  },
  {
    title: 'You’ll spot gaps before they cause problems',
    description: `
      All policies have exclusions. Comparing cover helps you avoid surprises when it matters most. No one wants to discover your lost luggage isn’t covered after it’s halfway to Lisbon - and you’re not.
    `,
    icon: V2IconsMagnifyingGlass,
    iconProps: {
      width: 48,
      height: 48
    }
  }
]

export const FIND_THE_RIGHT_TRAVEL_INSURANCE = [
  {
    title: 'Medical expenses and emergencies',
    description: `
      This includes hospital stays, doctor visits, and emergency evacuation. Many policies also cover dental emergencies and repatriation to your home country.
    `,
    icon: V2IconsHospital,
    iconProps: {
      width: 48,
      height: 48
    }
  },
  {
    title: 'Trip cancellations or interruptions',
    description: `
      Covers non-refundable expenses if you can't travel due to reasons like illness, injury, or natural disasters. Most policies now include optional COVID-related cover, which may cost extra.
    `,
    icon: V2IconsClose,
    iconProps: {
      width: 48,
      height: 48
    }
  },
  {
    title: 'Baggage and personal belongings',
    description: `
      Protection against loss, theft, or damage to your luggage and personal items. Some policies even include cover for essential items if your luggage is delayed.
    `,
    icon: V2IconsSuitcase,
    iconProps: {
      width: 48,
      height: 48
    }
  },
  {
    title: 'Rental vehicle excess',
    description: `
      If you hire a car and are involved in an accident or damage occurs, travel insurance can cover the excess fee often required by rental companies.
    `,
    icon: V2IconsCar,
    iconProps: {
      width: 48,
      height: 48
    }
  },
  {
    title: 'Accidental death or dismemberment',
    description: `
      Your travel insurer can provide financial support in the event of a serious accident during your trip.
    `,
    icon: V2IconsBookOpenText,
    iconProps: {
      width: 48,
      height: 48
    }
  },
  {
    title: 'Travel delays',
    description: `
      Most policies also cover additional costs for meals, accommodation, or alternative transport if your travel is delayed due to covered reasons.
    `,
    icon: V2IconsTimer,
    iconProps: {
      width: 48,
      height: 48
    }
  }
]

export const NEW_IN_TRAVEL_INSURANCE = [
  'Did you know that cover at sea isn’t automatically included in most travel insurance policies? Cruise cover is an optional add-on.',
  'COVID-19 coverage is now standard with many insurers, but always check what’s included. Long covid is still quite a new condition for insurers to include so if you need it on your policy, look for an insurer that specifically includes this condition.',
  'Adventure sport cover and winter sports insurance are increasingly common as Australians seek more thrill-based getaways.',
  'Rental vehicle excess cover and motorbike/scooter add-ons are in higher demand as more people explore independently.',
  'Domestic cover is still relevant, especially for flight cancellations, baggage issues, or rental car damage.'
]

export const TIERS_LIST = [
  {
    icon: V2IconsAirplane,
    iconProps: {
      width: 48,
      height: 48
    },
    title: 'Single-trip policies',
    desc: `
      Ideal for one-time travellers, this type of travel insurance covers a single journey for a set duration.
    `
  },
  {
    icon: V2IconsGlobe,
    iconProps: {
      width: 48,
      height: 48
    },
    title: 'Annual multi-trip policies',
    desc: `
      Best for frequent travellers, covering multiple trips within a year. If you travel often over a twelve month period.
    `
  },
  {
    icon: V2IconsShieldRegular,
    iconProps: {
      width: 48,
      height: 48
    },
    title: 'Basic cover',
    desc: `
      <strong>Usual Inclusions</strong><br />
      Covers essential medical expenses only.
      <br /><br /><br />
      
      <strong>Who is it for?</strong><br />
      Budget travellers, countries with reciprocal healthcare agreements.
    `
  },
  {
    icon: V2IconsShield,
    iconProps: {
      width: 48,
      height: 48
    },
    title: 'Standard cover',
    desc: `
      <strong>Usual Inclusions</strong><br />
      Includes medical expenses, tour cancellation, lost luggage, and some extras.
      <br /><br /><br />
      
      <strong>Who is it for?</strong><br />
      Most standard holidaymakers travelling on guided tours.
    `
  },
  {
    icon: V2IconsShieldCheck,
    iconProps: {
      width: 48,
      height: 48
    },
    title: 'Comprehensive cover',
    desc: `
      <strong>Usual Inclusions</strong><br />
      Medical costs, cancellation fees, lost or stolen luggage, adventure sports, additional benefits.
      <br /><br /><br />
      
      <strong>Who is it for?</strong><br />
      Those going on longer trips with complex itineraries moving through many countries - and travellers with complex medical needs.
    `
  }
]

export const TRAVEL_INSURANCE_COSTS = [
  '<strong>Your destination:</strong> Travelling somewhere remote or without reciprocal healthcare? Expect a higher premium. High risk destinations (e.g. travelling to a conflict zone) comes with higher premiums too.',
  '<strong>Your travel duration:</strong> Longer trips = more exposure to risk.',
  '<strong>Your age:</strong> Premiums often increase as you get older.',
  '<strong>Any pre-existing conditions your may have:</strong> Some insurers will cover these for an additional fee.',
  '<strong>Your excess:</strong> Higher excess = lower premium (but more out-of-pocket costs for you if you do need to claim).',
  '<strong>Level of cover:</strong> Comprehensive cover costs more, but offers peace of mind and lower costs if you do need to claim.'
]

export const TRAVEL_COSTS_TABLE_1 = {
  head: [
    {
      label: 'Destination',
      class: '!px-3 xxs:px-4'
    },
    {
      label: 'Average Cost (Basic)',
      class: '!px-3 xxs:px-4'
    },
    {
      label: 'Average Cost (Comprehensive)',
      class: '!px-3 xxs:px-4'
    }
  ],

  body: [
    [
      {
        value: '<strong>New Zealand</strong>'
      },
      {
        value: '$40'
      },
      {
        value: '$120'
      }
    ],
    [
      {
        value: '<strong>Indonesia (Bali)</strong>'
      },
      {
        value: '$55'
      },
      {
        value: '$160'
      }
    ],
    [
      {
        value: '<strong>United Kingdom</strong>'
      },
      {
        value: '$45'
      },
      {
        value: '$150'
      }
    ],
    [
      {
        value: '<strong>United States</strong>'
      },
      {
        value: '$65'
      },
      {
        value: '$190'
      }
    ],
    [
      {
        value: '<strong>Japan</strong>'
      },
      {
        value: '$50'
      },
      {
        value: '$170'
      }
    ]
  ]
}

export const TRAVEL_COSTS_TABLE_2 = {
  head: [
    {
      label: 'Destination',
      class: '!px-3 xxs:px-4'
    },
    {
      label: 'Average Cost (Basic)',
      class: '!px-3 xxs:px-4'
    },
    {
      label: 'Average Cost (Comprehensive)',
      class: '!px-3 xxs:px-4'
    }
  ],

  body: [
    [
      {
        value: '<strong>Sydney</strong>'
      },
      {
        value: '$20'
      },
      {
        value: '$60'
      }
    ],
    [
      {
        value: '<strong>Melbourne</strong>'
      },
      {
        value: '$22'
      },
      {
        value: '$65'
      }
    ],
    [
      {
        value: '<strong>Gold Coast</strong>'
      },
      {
        value: '$18'
      },
      {
        value: '$55'
      }
    ],
    [
      {
        value: '<strong>Perth</strong>'
      },
      {
        value: '$25'
      },
      {
        value: '$70'
      }
    ],
    [
      {
        value: '<strong>Cairns</strong>'
      },
      {
        value: '$23'
      },
      {
        value: '$68'
      }
    ]
  ]
}

export const FAQ_ITEMS = [
  {
    title: 'What is an ‘excess’?',
    content: `
      It’s what you pay out of pocket when you make a claim. For small claims (like lost earphones), it might not be worth claiming.
    `
  },
  {
    title: 'Is COVID-19 covered by travel insurance?',
    content: `
      Many insurers now include COVID cover, but check your fine print. Some charge extra, and inclusions vary wildly. This add-on premium can also be affected by your destination.
    `
  },
  {
    title: 'Can I extend my travel insurance cover?',
    content: `
      Usually yes, but you’ll need to apply before your current policy expires, and additional fees may apply.
    `
  },
  {
    title: 'Is stolen cash covered?',
    content: `
      Some policies include this, others don’t. Read your Product Disclosure Statement (PDS) carefully - or ask before you buy.
    `
  },
  {
    title: 'What’s the difference between travel and flight insurance?',
    content: `
      Flight insurance only covers delays and cancellations. Travel insurance covers your trip, belongings, and health.
    `
  },
  {
    title: 'When should you buy travel insurance?',
    content: `
      As soon as you’ve booked your trip. That way, you’re covered for cancellations or interruptions well before you pack your sunscreen. Things happen even before you leave home, such as family emergencies or health issues.
    `
  },
  {
    title: 'Can’t I get travel insurance through my credit card?',
    content: `
      You usually can. Especially if you book your trip this way, but beware because these policies are often limited. You may get broader, better value by comparing standalone policies.
    `
  }
]

export const TOOLTIPS = {
  destination: {
    title: 'Destination',
    description: 'Enter the countries that you are travelling to. You don’t have to enter stopover countries unless you’re staying for longer than 48 hours.'
  },
  daterange: {
    title: 'Travel dates',
    description: 'First, select your start date. Then, select a later date to complete your selection.'
  },
  commencementDate: {
    title: 'Commencement date',
    description: 'Enter the date you will leave your home to start your first trip.'
  },

  maxTripLength: {
    title: 'Maximum trip length',
    description: 'You can choose an International annual travel  insurance policy which will give you coverage for trip durations of 15, 30 or 60 days or a Domestic annual travel insurance policy which will give you coverage for trip durations of 15 or 30 days. If you\'re after long stay continuous coverage for over 30 days, Domestic or 60 days, International, you will need to buy a single trip insurance policy where you can purchase cover for up to 12 months.'
  },

  adultAges: {
    title: 'Adult ages',
    description: 'Enter each adult’s age at departure, separated by commas if there’s more than one.'
  },

  dependantAges: {
    title: 'Dependant ages',
    description: 'Enter the ages of any dependent children or grandchildren. Use 1 for kids under one and separate multiple ages with commas.'
  },

  extraCovers: {
    title: 'During your trip will you need cover for',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor qui impedit, provident ab minus, eius repellat illo accusamus dolores, enim obcaecati consequuntur expedita cum nesciunt architecto dicta quos quidem deleniti?'
  },

  sortedByLowestPrice: {
    title: 'How we rank your results?',
    description: 'We’ve listed the options starting with the cheapest first. We are not owned by an insurer, and don’t favour any provider on our panel.'
  },

  howToMakeMoney: {
    title: 'How do we make money?',
    description: 'Compare Club is free for users. We earn a commission from providers if you choose a product through our site, but this never affects how options are ranked, the results are always fair and objective.'
  },

  tripCancellation: {
    title: 'Trip Cancellation',
    description: 'If unexpected events stop you from travelling, this helps cover your prepaid trip costs like flights or accommodation when you can’t get a refund. Coverage applies for circumstances beyond your control and varies between policies.'
  },

  luggageCover: {
    title: 'Luggage cover',
    description: 'If your bags or personal belongings are lost, stolen, or damaged while you’re travelling, this cover helps you get back on track. The level of protection and claim limits differ by policy and providers.'
  },

  maximumExcess: {
    title: 'Maximum excess',
    description: 'This is the amount you’ll contribute if you make a claim. You can choose your preferred excess level when quoting policies.'
  },

  rentalCarCover: {
    title: 'Rental car cover',
    description: 'If your rental car is damaged or stolen, this cover helps pay the excess charged by the rental company. The amount covered and terms differ between policies and providers.'
  }
}

/**
 * NOTE: When adding a new slug to TRAVEL_INSURANCE_LANDING_PAGES, you must also
 * add it to the `travel-insurance/:slug(...)` route constraint in the
 * `pages:extend` hook in nuxt.config.ts. Otherwise the new slug won't match this
 * landing route and will fall through to [vertical]/[slug].vue, breaking the page.
 */
export const TRAVEL_INSURANCE_LANDING_PAGES = {
  international: {
    heroTitle: 'Compare International Travel Insurance',
    heroDescription: 'We help you find international travel insurance that fits your plans, not someone else\'s. From missed flights to lost bags, get the right cover at the right price.',
    pageTitle: 'Compare International Travel Insurance | Quotes & Cover Options',
    metaTitle: 'International Travel Insurance Comparison | Compare & Save',
    metaDescription: 'Compare international travel insurance options that match your trip. Find cover for medical, cancellations, lost luggage and more. Get quotes and choose with confidence.',
    ogTitle: 'Compare International Travel Insurance',
    ogDescription: 'Find international travel insurance that fits your plans. Compare cover options, prices and benefits in minutes.'
  },
  domestic: {
    heroTitle: 'Compare Domestic Travel Insurance',
    heroDescription: 'We help you find domestic travel insurance that fits your plans, not someone else\'s. From missed flights to lost bags, get the right cover at the right price.',
    pageTitle: 'Compare Domestic Travel Insurance | Quotes & Cover Options',
    metaTitle: 'Domestic Travel Insurance Comparison | Compare & Save',
    metaDescription: 'Compare domestic travel insurance options for trips within Australia. Cover cancellations, lost luggage and more. Find the right policy at the right price.',
    ogTitle: 'Compare Domestic Travel Insurance',
    ogDescription: 'Find domestic travel insurance that fits your plans. Compare cover options, prices and benefits in minutes.'
  },
  'annual-multi-trip': {
    heroTitle: 'Compare Annual Multi-Trip Insurance',
    heroDescription: 'We help you find annual multi-trip insurance that fits your plans, not someone else\'s. From missed flights to lost bags, get the right cover at the right price.',
    pageTitle: 'Compare Annual Multi-Trip Insurance | Cover All Year',
    metaTitle: 'Annual Multi-Trip Travel Insurance | Compare & Save',
    metaDescription: 'Compare annual multi-trip travel insurance and stay covered for every trip this year. Ideal for frequent travellers. Find the right cover at the right price.',
    ogTitle: 'Compare Annual Multi-Trip Insurance',
    ogDescription: 'Travel more with less hassle. Compare annual multi-trip insurance options and stay covered all year round.'
  },
  senior: {
    heroTitle: 'Compare Senior Travel Insurance',
    heroDescription: 'Travel comes with surprises. Your insurance shouldn’t. We’ll help you find cover that fits your trip. From take-off to touchdown.',
    pageTitle: 'Compare Senior Travel Insurance | Cover for Over 50s',
    metaTitle: 'Senior Travel Insurance Comparison | Compare & Save',
    metaDescription: 'Compare senior travel insurance designed for over 50s. Find cover for medical, cancellations and more. Travel with confidence at the right price.',
    ogTitle: 'Compare Senior Travel Insurance',
    ogDescription: 'Travel with confidence. Compare senior travel insurance options tailored to your trip and needs.'
  },
  cheap: {
    heroTitle: 'Cheap Travel Insurance That Keeps You Protected',
    heroDescription: 'Your trip shouldn’t cost a fortune. Your insurance shouldn’t either. We’ll help you find smart cover that actually fits how you travel.',
    pageTitle: 'Cheap Travel Insurance | Compare Affordable Cover',
    metaTitle: 'Cheap Travel Insurance Comparison | Save Without Compromise',
    metaDescription: 'Compare cheap travel insurance options without cutting essential cover. Find affordable policies for medical, cancellations and more.',
    ogTitle: 'Cheap Travel Insurance That Keeps You Protected',
    ogDescription: 'Find affordable travel insurance that still covers what matters. Compare options and save without compromising.'
  },
  medical: {
    heroTitle: 'Looking For Medical Travel Insurance?',
    heroDescription: 'Medical costs overseas can add up fast. We help you find the right cover before you go. So you’re protected if something goes wrong.',
    pageTitle: 'Medical Travel Insurance | Compare Cover Options',
    metaTitle: 'Medical Travel Insurance Comparison | Compare & Save',
    metaDescription: 'Compare medical travel insurance for overseas trips. Get cover for illness, injuries and emergencies abroad. Find the right policy before you travel.',
    ogTitle: 'Looking For Medical Travel Insurance?',
    ogDescription: 'Medical costs overseas can add up fast. Compare travel insurance options and get the right cover before you go.'
  }
}
